import React from 'react';

import { ReactComponent as InstallIcon } from '../../assets/install.svg';
import { ReactComponent as PdfIcon } from '../../assets/pdf.svg';
import { ReactComponent as UploadIcon } from '../../assets/upload.svg';
import styles from './styles.module.scss';

const ExemplarUpload = ({ file, setFile }) => {
  // TODO: Add real file handling
  const handleUploadClick = () => {
    // setFile({
    //   name: 'Assignment_Exemplar_V1.pdf',
    //   pages: '',
    //   id: 'mock-123'
    // });
  };

  const handleRemove = () => setFile(null);

  const handlePageChange = (e) => {
    setFile({ ...file, pages: e.target.value });
  };

  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <InstallIcon /> <span>Upload Exemplar</span>
      </div>

      {!file ? (
        <div className={styles.dropzone} onClick={handleUploadClick}>
          <UploadIcon className={styles.dropzoneIcon} />
          <p>
            <span className={styles.linkText}>Choose file to upload</span> or
            drag and drop
          </p>
        </div>
      ) : (
        <div className={styles.fileRow}>
          <div className={styles.fileInfo}>
            <PdfIcon />
            <span className={styles.fileName}>{file.name}</span>
          </div>

          <div className={styles.fileActions}>
            <input
              type="text"
              placeholder="No. of pages"
              className={styles.pagesInput}
              value={file.pages}
              onChange={handlePageChange}
            />
            <button
              className={styles.removeFile}
              onClick={handleRemove}
              aria-label="Remove file"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExemplarUpload;
